import { useSelector } from 'react-redux';
import { useDailyDataQuery } from '@/components/analyticsPage/tabPanels/components/drawers/dataDrawer/components/esgDataTab/components/dailyData/hooks/useDailyDataQuery';
import Filters from '@/components/analyticsPage/tabPanels/components/drawers/components/Filters';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '@/components/ui/checkbox';
import DatePicker from '@/components/ui/datepicker';
import moment from 'moment';

const CrossSectional = () => {
  const query = useSelector((state: any) => state.analytics.dataQuery.esgData.dailyData);
  const [setQuery] = useDailyDataQuery();
  const [t] = useTranslation('analytics');

  return (
    <div className="m-4 space-y-4">
      <div className="w-full space-y-1">
        <div className="font-medium">{t('Time window')}</div>
        <DatePicker
          value={new Date(query.from)}
          className="w-full"
          onChange={(e) => setQuery({ from: moment(e).format('YYYY/MM/DD') })}
        />
      </div>
      <div className="space-y-1">
        <div className="font-medium">{t('Index')}</div>
        <div className="space-y-1.5">
          <div className="flex items-center gap-2">
            <Checkbox
              checked
              disabled
              className="data-[state=checked]:bg-primary data-[state=checked]:border-primary border-primary"
            />
            ESG Category
          </div>
          <Filters filters={query.filters} setQuery={setQuery} originalFilter={query.filters} />
        </div>
      </div>
    </div>
  );
};

export default CrossSectional;
